"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    SETTINGS_URL: ()=>SETTINGS_URL,
    fetchAppSettings: ()=>fetchAppSettings,
    activateChangeEnv: ()=>activateChangeEnv,
    isDemoPhone: ()=>isDemoPhone,
    isSwitchEnvCode: ()=>isSwitchEnvCode,
    devLog: ()=>devLog,
    setQaAgent: ()=>setQaAgent,
    useQaAgent: ()=>useQaAgent,
    eventApiKeys: ()=>eventApiKeys
});
const _react = require("react");
const _lodash = require("lodash");
const _settingsJson = /*#__PURE__*/ _interopRequireDefault(require("./settings.json"));
require("./events");
const _ = require("..");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const SETTINGS_URL = 'https://s3.amazonaws.com/springbig-mobile-app';
const store = {
    howManyTaps: 7,
    taps: 0,
    waiting: false,
    settings: null,
    isQaAgent: false
};
const fetchAppSettings = async ()=>{
    const res = await fetch(`${SETTINGS_URL}/settings.json`, {
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            'user-agent': 'springbig-mobile-app'
        }
    });
    const settings = await res.json();
    store.settings = settings || _settingsJson.default;
    // await new Promise((res) => setTimeout(res, 200));
    // store.settings = Settings;
    store.howManyTaps = _settingsJson.default.tapsToSwitchEnv;
    if (store.isQaAgent) {
        setQaAgent();
    }
};
const clearTaps = (0, _lodash.debounce)(()=>{
    if (!store.waiting) {
        store.taps = 0;
    }
}, 1000);
const activateChangeEnv = (callback)=>{
    if (!store.settings) {
        return;
    }
    clearTaps();
    store.taps += 1;
    if (store.taps === store.howManyTaps) {
        if (store.isQaAgent) {
            callback();
            return;
        }
        store.waiting = true;
        setTimeout(()=>{
            if (store.taps === store.howManyTaps) {
                callback();
            }
            store.waiting = false;
            store.taps = 0;
        }, 2000);
    }
};
const isDemoPhone = (phone)=>{
    if (!store.settings) {
        return;
    }
    const cleanPhone = (phone + '').replace(/[^\d]/g, '');
    const demoPhones = store.settings.demoPhones.map((p)=>p.replace(/[^\d]/g, ''));
    return demoPhones.includes(cleanPhone);
};
const isSwitchEnvCode = (code)=>{
    if (!store.settings) {
        return;
    }
    return code === store.settings.switchEnvCode;
};
const devLog = (...msgs)=>console?.log(...msgs);
const setQaAgent = (to = true)=>{
    if (to === true) {
        store.howManyTaps = 3;
        store.isQaAgent = to;
        return;
    }
    store.howManyTaps = store.settings?.tapsToSwitchEnv || 7;
    store.isQaAgent = false;
};
const useQaAgent = ()=>{
    const { value , setValue  } = (0, _.useStorageValue)('isQaAgent');
    (0, _react.useEffect)(()=>{
        setQaAgent(!!value);
    }, [
        value
    ]);
    return {
        isQaAgent: value,
        setQaAgent: (to = true)=>{
            setValue(to);
        }
    };
};
const eventApiKeys = ()=>store.settings.eventsApiKeys;
